/* eslint-disable */
import axios from 'axios'
const state = {
    subcates:[]
};
const getters = {
    allSubCate()
    {
        return state.subcates
    }
};
const actions = {
    async addSubCategory({commit},payload){
        var formdata = new FormData();
        formdata.append("ImageFile",payload.image)
        formdata.append("name",payload.name)
        formdata.append("CategoryId",payload.categoryId)
        formdata.append("Description",payload.Description)

        let response = await axios.post("http://localhost:5290/api/Category/GetAllSubCategory",formdata)
        commit("addsubcate",response.data)
        return response.data;
    },
    async subCategoryList()
    {
        
    }
};
const mutations = {
    
};

export default {
    state,
    getters,
    actions,
    mutations
}